import { render, staticRenderFns } from "./itemStdListDl.vue?vue&type=template&id=6145345c&"
import script from "./itemStdListDl.vue?vue&type=script&lang=js&"
export * from "./itemStdListDl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports